import React, { useEffect } from "react"
import { connect } from "react-redux"
import { cadastrarEvento } from "../utils/GoogleAnalytics"

export const ContainerPagina = (props) => {
	const { className, codigoLaboratorio, nomeTelaAnalytics, children } = props

	useEffect(() => {
		if (codigoLaboratorio && nomeTelaAnalytics)
			cadastrarEvento(nomeTelaAnalytics, codigoLaboratorio)
	}, [codigoLaboratorio, nomeTelaAnalytics])

	return <div className={`container-pagina ${className || ""}`}>{children}</div>
}

const mapStateToProps = (state) => {
	return {
		codigoLaboratorio: state.login.laboratorio.codigo,
	}
}

export default connect(mapStateToProps)(ContainerPagina)
